<div
  class="impersonation-banner"
  *ngIf="tenantId$ | async as tenantId"
  role="status"
  aria-live="polite"
>
  <div class="impersonation-banner__inner">
    <span class="impersonation-banner__icon" nz-icon nzType="user-switch" nzTheme="outline"></span>
    <span class="impersonation-banner__text">
      <strong>Mode institution actif</strong>
      <ng-container *ngIf="tenantLabel$ | async as label">
        · {{ label }}
      </ng-container>
    </span>
    <button
      type="button"
      class="impersonation-banner__exit"
      (click)="exit()"
      title="Quitter le mode institution"
    >
      <span nz-icon nzType="logout" nzTheme="outline"></span>
      Quitter
    </button>
  </div>
</div>
